class TFPContactForm extends HTMLElement {
  #controller;
  #frame;

  connectedCallback() {
    if (this.#controller) return;

    const form = this.querySelector(':scope > form.tfp-contact-page__form');
    if (!(form instanceof HTMLFormElement)) return;

    this.#controller = new AbortController();
    form.addEventListener('invalid', this.#onInvalid, {
      capture: true,
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;

    if (this.#frame) cancelAnimationFrame(this.#frame);
    this.#frame = undefined;
  }

  #onInvalid = (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) {
      return;
    }

    if (!this.contains(field)) return;
    if (this.#frame) return;

    this.#frame = requestAnimationFrame(() => {
      this.#frame = requestAnimationFrame(() => {
        this.#frame = undefined;
        this.#reveal(field);
      });
    });
  };

  #reveal(field) {
    if (!this.isConnected || !field.isConnected || document.activeElement !== field || !field.matches(':invalid')) return;

    const fieldGroup = field.closest('.tfp-contact-page__field');
    if (!(fieldGroup instanceof HTMLElement)) return;

    const headerBottom = Array.from(document.querySelectorAll('#header-group .header-section')).reduce(
      (bottom, header) => {
        if (!(header instanceof HTMLElement)) return bottom;

        const position = getComputedStyle(header).position;
        if (position !== 'fixed' && position !== 'sticky') return bottom;

        const rect = header.getBoundingClientRect();
        if (rect.top > 1 || rect.bottom <= 0) return bottom;
        return Math.max(bottom, rect.bottom);
      },
      0
    );
    const gap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--padding-sm')) || 8;
    const requiredTop = headerBottom + gap;
    const currentTop = fieldGroup.getBoundingClientRect().top;

    if (currentTop >= requiredTop) return;
    window.scrollBy({ top: currentTop - requiredTop, left: 0, behavior: 'instant' });
  }
}

if (!customElements.get('tfp-contact-form')) {
  customElements.define('tfp-contact-form', TFPContactForm);
}
